import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { UTILS } from "utils";
import { API } from "api";
import { CONSTANTS as C } from "config";
// import PaymentTypes from "./StorePaymentMethodSection";
// import WorkingHours from "./StoreHoursSection";
import RadioButton from "./../../../RadioButton";
import AppSwitch from "components/ui/AppSwitch.jsx";
import AppHeading2 from "components/ui/AppHeading2.jsx";
import AppInput from "components/ui/AppInput.jsx";
import AppSelect from "components/ui/AppSelect.jsx";
import AppSimpleText from "components/ui/AppSimpleText.jsx";
import StoreHoursSection from "./HoursSelection"
import AppDatePicker from "components/ui/AppDatePicker.jsx";
import useDeliveryFeeWaiveoff from "./hooks/useDeliveryFeeWaiveoff"
// import PreOrderingWidgetForDelivery from "./PreOrderingWidgetForDelivery";
// import OrderManagement from "./OrderManagement";
// import DeliveryChargesWaveOff from "./DeliveryChargesWaveOff";
// import DeliveryManagement from "./DeliveryManagement";
import {
  getHMinutSlotsTill8Hors,
  getThirdsDaysArrayWithDayLebel,
  getNumOfDaysWithZero,
} from "./constants";
import moment from "moment-timezone";
import { TimePicker } from "antd";
import AppCollapse from "components/ui/AppCollapse.jsx";


function Delivery({ store, addStore, type, setStore, defaultOpen = false }) {
  const [serviceTypes, setServiceTypes] = useState([]);
  const { t } = useTranslation();
  const { handleOnOrderAmount, handleDateRange } = useDeliveryFeeWaiveoff({
    setStore,
    store,
  });

  /** ISO string, or Unix seconds (10-digit) from API — AppDatePicker needs a value `moment()` parses correctly. */
  const parseWaiverDateForPicker = (v) => {
    if (v == null || v === "") return undefined;
    const n = typeof v === "number" ? v : Number(v);
    if (!Number.isNaN(n) && String(Math.floor(Math.abs(n))).length === 10) {
      return moment.unix(n);
    }
    return v;
  };

  const onWaiverRangeDateChange = (key) => (date) => {
    handleDateRange(
      key,
      date ? moment(date).locale("en").format("YYYY-MM-DDTHH:mm:ssZZ") : null
    );
  };

  const infoMessages = [
    {
      message:
        "To Receive Payments in Your Bank Account Please email us at",
      separator: "or",
      links:[
        {
          href: `mailto:support@comera.io`,
          text: "support@comera.io",
          target: "_blank",
        },
        {
          href: `https://wa.me/${(process.env.REACT_APP_SUPPORT_MOBILE || "").replace(/[^0-9]/g, "")}?text=How%20can%20we%20help?`,
          text: "Contact our Support Team",
          target: "_blank",
        },
      ],
    },
    {
      message: "To Enable Payment Methods (Cash, Card Payments, Card on Delivery, etc.) ",
      separator: "and we’ll help you activate the payment options you need",
      links:[
        {
          href: `https://wa.me/${(process.env.REACT_APP_SUPPORT_MOBILE || "").replace(/[^0-9]/g, "")}?text=How%20can%20we%20help?`,
          text: "Contact our Support Team",
          target: "_blank",
        },
      ],
    },
  ];
  const getServiceTypes = async () => {
    const userDetail = UTILS.getCurrentUser();
    const result = await API.GET_SERVICE_TYPES({
      token: userDetail.token,
    });
    if (result && result.success === 1) {
      setServiceTypes(result.data);
    } else {
    }
  };
  useEffect(() => {
    getServiceTypes();
  }, []);
  const toggleDelivery = (isDeliveryEnabled, key) => {
    if (isDeliveryEnabled) {
      setStore((store) => ({
        ...store,
        values: {
          ...store.values,
          [C.ISDELIVERYENABLED]: !isDeliveryEnabled,
          [C.KEY_SERVICE_TYPES]: store.values[C.KEY_SERVICE_TYPES].filter(
            (item) => item !== key
          ),
        },
      }));
    } else {
      setStore((store) => ({
        ...store,
        values: {
          ...store.values,
          [C.ISDELIVERYENABLED]: !isDeliveryEnabled,
          serviceType: [...store.values.serviceType, key],
        },
      }));
    }
  };
  const isON = (item) => {
    const arr = store.values[C.KEY_SERVICE_TYPES];
    const found = arr?.find((obj) => obj === item);
    return found ? true : false;
  };
  
  const getValue = (key) => {
    if (store && store.values[key]) return store.values[key];
    else return "";
  };

  const handlePaymentTypes = (key, val) => {
    const v = key;
    let paymentArr = store.values[C.KEY_PAYMENT_TYPES];
    if (val) {
      paymentArr.push(v);
    } else {
      const index = paymentArr.indexOf(v);
      if (index > -1) paymentArr.splice(index, 1);
    }
    setStore((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        [C.KEY_PAYMENT_TYPES]: paymentArr,
      },
      errors: {
        ...prevState.errors,
      },
    }));
  };

  const handleTwentyFourHours = (key, val) => {
    setStore((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        [key]: val,
      },
      errors: {
        ...prevState.errors,
      },
    }));

    if (val) {
      setStore((prevState) => ({
        ...prevState,
        values: {
          ...prevState.values,
          [key]: val,
          workingHours: {
            saturdayStartTime: C.START_TIME_24_HOURS,
            saturdayEndTime: C.END_TIME_24_HOURS,
            saturdayStartTimeSlot2: null,
            saturdayEndTimeSlot2: null,

            sundayStartTime: C.START_TIME_24_HOURS,
            sundayEndTime: C.END_TIME_24_HOURS,
            sundayStartTimeSlot2: null,
            sundayEndTimeSlot2: null,

            mondayStartTime: C.START_TIME_24_HOURS,
            mondayEndTime: C.END_TIME_24_HOURS,
            mondayStartTimeSlot2: null,
            mondayEndTimeSlot2: null,

            tuesdayStartTime: C.START_TIME_24_HOURS,
            tuesdayEndTime: C.END_TIME_24_HOURS,
            tuesdayStartTimeSlot2: null,
            tuesdayEndTimeSlot2: null,

            wednesdayStartTime: C.START_TIME_24_HOURS,
            wednesdayEndTime: C.END_TIME_24_HOURS,
            wednesdayStartTimeSlot2: null,
            wednesdayEndTimeSlot2: null,

            thursdayStartTime: C.START_TIME_24_HOURS,
            thursdayEndTime: C.END_TIME_24_HOURS,
            thursdayStartTimeSlot2: null,
            thursdayEndTimeSlot2: null,

            fridayStartTime: C.START_TIME_24_HOURS,
            fridayEndTime: C.END_TIME_24_HOURS,
            fridayStartTimeSlot2: null,
            fridayEndTimeSlot2: null,

            sunday: true,
            saturday: true,
            friday: true,
            thursday: true,
            wednesday: true,
            tuesday: true,
            monday: true,
          },
        },
        errors: {
          ...prevState.errors,
        },
      }));
    }
  };

  const handleQuickOrder = (key, val) => {
    setStore((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        [key]: val,
      },
      errors: {
        ...prevState.errors,
      },
    }));
  };

  const handleStoreInfo = (key, val) => {
    setStore((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        [key]: val,
      },
    }));
  };

  const handlePreOrderingTiming = (key, val) => {
    setStore((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        preOrderSettingsForDelivery: {
          ...prevState.values.preOrderSettingsForDelivery,
          [key]: val,
        },
      },
      errors: {
        ...prevState.errors,
      },
    }));
  };

  const handleInputValue = (key, val) => {
      const value = UTILS.NumberConversion(val);
      let time = Number(value);
      // if (time >= 17 && preOrderTimig?.minTimeInAdvanceUnit === "hours") {
      //   setError(t("Minimum Lead Time should be less than 17 hours"));
      //   return;
      // }
      // if (time >= 960 && preOrderTimig?.minTimeInAdvanceUnit === "minutes") {
      //   setError(t("Minimum Lead Time should be less than 960 minutes"));
      //   return;
      // }
      // setError("");
      handlePreOrderingTiming(key, time);
    };

  /** Minimum order for delivery charge waiver — must use handleOnOrderAmount, not handlePreOrderingTiming. */
  const handleWaiverOrderAmount = (key, val) => {
    const value = UTILS.NumberConversion(val);
    if (
      value <= 0 &&
      store?.values?.deliveryChargesWaiverInfo?.onOrderAmount?.isEnabled
    ) {
      handleOnOrderAmount(key, null);
    } else {
      handleOnOrderAmount(key, value);
    }
  };
  return (
    <div className="w-full mb-3">
      <AppCollapse
          defaultOpen={defaultOpen}
          title={t("Delivery Options")}
          subtitle={t("Set how and where you deliver orders.")}
        >
          <div className="space-y-6">

            {/* Delivery Toggle */}
            <div className="flex items-center">
              <AppSwitch label={t("Delivery")} checked={isON(serviceTypes[0]?._id)} labelLeft={false} onChange={(val)=>toggleDelivery( store.values[C.ISDELIVERYENABLED], serviceTypes[0]?._id)}/>
            </div>
            {isON(serviceTypes[0]?._id) && (
              <>
              <div className="space-y-3">
                <AppHeading2>{t("Supported Payment Methods?")}</AppHeading2>
                <ul className="px-5 text-blue-600 text-16px space-y-2 list-disc">
                  {infoMessages.map((item,index)=>(
                  <li key={index} className="text-sm leading-relaxed">
                  <span>{t(item.message)} </span>
                  {item.links.map((link, i) => (
                    <React.Fragment key={i}>
                      <a
                        href={link.href}
                        target={link.target}
                        rel="noopener noreferrer"
                        className="text-red-600 underline mx-1"
                      >
                        {t(link.text)}
                      </a>
                      {i < item.links.length - 1 && <span>{t(item.separator)}</span>}
                    </React.Fragment>
                  ))}
                  {item.links.length === 1 && <span>{t(item.separator)}</span>}.
                </li>
                
                  ))}
                </ul>
                  {/* <AppSimpleText> </AppSimpleText>
                <div className="flex items-center">
                  <AppSwitch label="Card on Delivery" labelLeft={false} />
                </div>

                <div className="flex items-center">
                  <AppSwitch label="Cash on Delivery" labelLeft={false} />
                </div>

                <div className="flex items-center">
                  <AppSwitch
                    label="Online Payment (Credit/Debit Card)"
                    labelLeft={false}
                  />
                </div> */}
              </div>
              <div className="space-y-3">
                <AppHeading2>{t("Delivery Management")}</AppHeading2>

                <div className="flex items-center">
                  <AppSwitch
                    label={t(`Deliver within  ${store?.values?.city ?? "same city"}`)}
                    labelLeft={false}
                    checked={store?.values?.sameCityDelivery}
                    onChange={(val) =>
                      setStore((prevState) => ({
                        ...prevState,
                        values: {
                          ...prevState.values,
                          ["sameCityDelivery"]: val,
                        },
                        errors: {
                          ...prevState.errors,
                          ["sameCityDelivery"]: "",
                        },
                      }))
                    }
                  />
                </div>
                </div>

              {/* Preparation Time */}
              <AppInput
                label="Average Preparation Time"
                placeholder="Example 30 Mins"
                value={store?.values?.averagePrepTime}
                onInput={(e)=>handleStoreInfo("averagePrepTime", e.target.value)}
              />

              {/* ASAP Orders */}
              <div className="flex items-center">
                <AppSwitch label={t("Accept ASAP orders")} labelLeft={false} checked={store?.values?.isAcceptQuickOrderForDelivery} onChange={(val)=>handleStoreInfo("isAcceptQuickOrderForDelivery", val)} />
              </div>

              {/* Pre-Orders */}
              <div className="space-y-3">
                <AppHeading2>{t("Do you want to accept pre-orders?")}</AppHeading2>

                <div className="flex items-center">
                  <AppSwitch
                    label={t("Accept pre-orders")}
                    labelLeft={false}
                    checked={store?.values?.isPreOrderEnabledForDelivery}
                    onChange={(val) =>
                      handleStoreInfo("isPreOrderEnabledForDelivery", val)
                    }
                  />
                </div>

                {store?.values?.isPreOrderEnabledForDelivery && (
                  <div className="flex items-center">
                    <AppSwitch
                      label="Accept Same Day Pre-Orders"
                      labelLeft={false}
                      checked={
                        store?.values?.preOrderSettingsForDelivery
                          ?.acceptTodayPreOrders
                      }
                      onChange={(val) =>
                        handlePreOrderingTiming("acceptTodayPreOrders", val)
                      }
                    />
                  </div>
                )}
              </div>

              {/* \ */}
              {store?.values?.isPreOrderEnabledForDelivery && (
              <>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <AppSelect 
                  label="Minimum Lead Time Unit" 
                  value={store?.values?.preOrderSettingsForDelivery?.minTimeInAdvanceUnit}
                  placeholder={t("Select Unit")}
                  onChange={(e)=>{handlePreOrderingTiming("minTimeInAdvanceUnit",e);handlePreOrderingTiming("minTimeInAdvance",'')}}
                  options={[
                    {
                      _id: "1",
                      label: t("Hours"),
                      value: "hours",
                    },
                    {
                      _id: "2",
                      label: t("Minutes"),
                      value: "minutes",
                    },
                  ]}

                />
                <AppInput label="Enter Minimum Lead Time" placeholder={t("Enter Minimum Lead Time")} value={store?.values?.preOrderSettingsForDelivery?.minTimeInAdvance} onInput={(e)=>handlePreOrderingTiming("minTimeInAdvance", Number(e.target.value))} />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <AppSelect 
                  label="Max Days In Advance" 
                  placeholder={t("select minutes")}
                  value={store?.values?.preOrderSettingsForDelivery?.maxDaysInAdvance}
                  options={getThirdsDaysArrayWithDayLebel()}
                  onChange={(e)=>handlePreOrderingTiming("maxDaysInAdvance",e)}
                />
                <AppSelect 
                  label="Slot Length"
                  placeholder={t("Select Slot Length")}
                  value={store?.values?.preOrderSettingsForDelivery?.timeInterval}
                  options={getHMinutSlotsTill8Hors()}
                  onChange={(e)=>handlePreOrderingTiming("timeInterval",e)}
                   />
              </div>

              <AppSelect 
                label="Minimum Days In Advance" 
                value={store?.values?.preOrderSettingsForDelivery?.minDaysInAdvance}
                placeholder={t("select minutes")}
                options={getNumOfDaysWithZero()}
                onChange={(e)=>handlePreOrderingTiming("minDaysInAdvance",e)}
              />
              </>
              )}
              <div className="space-y-3">
                <AppHeading2>
                  Delivery Charges Wave Off
                </AppHeading2>

                <div className="flex items-center">
                  <AppSwitch
                    label={t("On Order Amount")}
                    checked={store?.values?.deliveryChargesWaiverInfo?.onOrderAmount?.isEnabled}
                    labelLeft={false}
                    onChange={(e)=>handleOnOrderAmount('isEnabled',e)}
                  />
                </div>
                {
                  store?.values?.deliveryChargesWaiverInfo?.onOrderAmount?.isEnabled && 
                  <div className="flex items-center w-1/2 pr-3">
                    <AppInput
                      label="Enter Minimum Order Amount"
                      labelLeft={false}
                      mandatory={true}
                      placeholder={t("Enter Minimum Order Amount")}
                      value={store?.values?.deliveryChargesWaiverInfo?.onOrderAmount?.amount}
                      onInput={(e) => handleWaiverOrderAmount("amount", e.target.value)}
                    />
                  </div>
                }
                

                <div className="flex items-center">
                  <AppSwitch
                    label={t("On Date Range")}
                    checked={store?.values?.deliveryChargesWaiverInfo?.onDateRange?.isEnabled}
                    labelLeft={false}
                    onChange={(e)=>handleDateRange('isEnabled',e)}
                  />
                </div>
                {store?.values?.deliveryChargesWaiverInfo?.onDateRange
                  ?.isEnabled && (
                  <div className="grid w-full grid-cols-1 gap-3 md:grid-cols-2">
                    <AppDatePicker
                      label="Start Date"
                      value={parseWaiverDateForPicker(
                        store?.values?.deliveryChargesWaiverInfo?.onDateRange
                          ?.startDateTime
                      )}
                      onChange={onWaiverRangeDateChange("startDateTime")}
                    />
                    <AppDatePicker
                      label="End Date"
                      value={parseWaiverDateForPicker(
                        store?.values?.deliveryChargesWaiverInfo?.onDateRange
                          ?.endDateTime
                      )}
                      onChange={onWaiverRangeDateChange("endDateTime")}
                    />
                  </div>
                )}
                
              </div>

              {/* Store Hours */}
              <div className="space-y-3">
                <AppHeading2>
                  {t("Set the hours your store is open for delivery")}
                </AppHeading2>

                <div className="flex items-center">
                  <AppSwitch
                    label={t("Open 24 Hours to Accept Orders")}
                    labelLeft={false}
                    checked={store?.values?.isStoreOpen24Hours}
                    onChange={(e)=>handleTwentyFourHours('isStoreOpen24Hours',e)}
                  />
                </div>
                {
                  !store?.values?.isStoreOpen24Hours && 
                  <div className="w-full">
                    <StoreHoursSection store={store} setStore={setStore} hoursField="workingHours" />
                  </div>
                }
                
              </div>
              
            </>
          )}
            {/* Payment Methods */}
            

          </div>
        </AppCollapse>
    </div>
  );
}

export default Delivery;
